import React, { useState } from "react";
import { Button, Card, Form, Input, message, Modal} from "antd";
import HeaderComponent from "../component/header";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { api_register } from "../api/verify";

const RegisterPage: React.FC = () => {
  
    const [searchParams] = useSearchParams();
    const session = searchParams.get("session");
    const navigate = useNavigate();
    
    console.log(session)
    const onFinish = (values: { id: string; password: string }) => {
        if (session == null){
            Modal.error({
                content: "Wrong request",
            });
            return
        }
        api_register(values.id, values.password, session)
        .then((res) => {
            if (res.bSuccess)
            {
                message.success(res.msg)
                navigate("/login");
            }
            else{
                message.error(res.msg)
            }
        })
        .catch((error) => {
        console.error("An error occurred:", error.message);
        return
        });        
    };
    
    return (
        <div>
            <HeaderComponent />
            <div className="flex justify-center items-center body-height  text-style">
                <Card className="w-80 shadow-lg">
                    <h2 className="text-2xl font-bold text-center mb-4 text-style">Register</h2>
                    <Form
                    name="Register"
                    onFinish={onFinish}
                    layout="vertical"
                    initialValues={{ remember: true }}
                    >
                    <Form.Item
                        className='custom-font'
                        name="id"
                        label="ID"
                        rules={[
                        { required: true, message: "Please input your ID!" },
                        ]}
                    >
                        <Input prefix={<UserOutlined />} />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        label="Password"
                        rules={[
                        { required: true, message: "Please input your password!" },
                        { min: 6, message: "The length of password must be at least 6 characters." },
                        ]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="••••••" />
                    </Form.Item>

                    <Form.Item
                        name="password2"
                        dependencies={['password']}
                        label="Re-password"
                        rules={[
                            { required: true, message: 'Please reenter your password!' },
                            ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                return Promise.resolve();
                                }
                                return Promise.reject(new Error('The passwords do not match!'));
                            },
                            }),
                        ]}
                    >
                        <Input.Password prefix={<LockOutlined />} className='register-input-style' placeholder="••••••"/>
                    </Form.Item>

                    <Form.Item className='flex justify-center'>
                        <Button type="primary" htmlType="submit" className="w-32 text-style">
                            Register
                        </Button>
                    </Form.Item>
                    </Form>
                </Card>
            </div>
        </div>
    );
};

export default RegisterPage;